var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaclty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 7.51367C4.11929 7.51367 3 6.39438 3 5.01367C3 3.63296 4.11929 2.51367 5.5 2.51367C6.88071 2.51367 8 3.63296 8 5.01367C8 6.39438 6.88071 7.51367 5.5 7.51367Z",
    fill: "#109615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.26316 2.51367H18.8684C20.322 2.51367 21.5 3.63314 21.5 5.01367C21.5 5.97441 21.5 6.80918 21.5 7.22796C21.5 7.38567 21.3823 7.51367 21.2368 7.51367H9.26316C9.11743 7.51367 9 7.38567 9 7.22796V2.79938C9 2.64141 9.11743 2.51367 9.26316 2.51367Z",
    fill: "#109615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.0155 0.286395V8.19536H21.2312C21.3798 8.19536 21.5 8.3173 21.5 8.46808V14.7407C21.5 14.8912 21.3798 15.0134 21.2312 15.0134H19.753C19.6044 15.0134 19.4843 14.8912 19.4843 14.7407V11.6045H2.0155V14.7409C2.0155 14.8915 1.89511 15.0137 1.74676 15.0137H0.268511C0.120161 15.0134 0 14.8912 0 14.7407V0.286395C0 0.135609 0.120161 0.0136719 0.268749 0.0136719H1.747C1.89582 0.0136719 2.0155 0.135609 2.0155 0.286395Z",
    fill: "#109615"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaclty);
export default __webpack_public_path__ + "static/media/faclty.d5cad45493d3f30fceb49d0660acb6b5.svg";
export { ForwardRef as ReactComponent };